var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column ga-2",
      attrs: { "data-qa": "lpu_information_field" },
    },
    [
      _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-subtitle-1 text--text" },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }